module.exports = __webpack_public_path__ + "static/olumide-24e0b62e04839388b73c43f6ac185afd.jpg";